import React from "react";
import {InputAdornment} from "@mui/material";
import {Box, Colors, Text} from "@bounce/shared/ui";
import {TextField} from "../../../../ui/components";
import {BaseValueInputProps} from "./types";

type Props = BaseValueInputProps & {
  isFraction: boolean;
  isBalance?: boolean;
};

const NumericValueInput: React.FC<Props> = ({
  value,
  valueError,
  onChange,
  isFraction,
  isBalance = false,
  showLabel = true,
}) => (
  <Box sx={{flex: 2}}>
    {showLabel && (
      <Text size={12} sx={{color: Colors.grey._700, mb: 0.5}}>
        Value
      </Text>
    )}
    <TextField
      size="small"
      fullWidth
      type="number"
      placeholder="Amount"
      value={value === null || value === undefined ? "" : (value as number | string)}
      onChange={(e) => {
        const next = e.target.value;
        onChange(next === "" ? "" : Number(next));
      }}
      onKeyDown={(e) => {
        if (e.key === "-" || e.key === "e" || e.key === "E") e.preventDefault();
      }}
      InputSx={{alignItems: "center"}}
      InputProps={{
        inputProps: isFraction ? {min: 0, max: 1, step: 0.01} : {min: 0},
        startAdornment: isBalance ? <InputAdornment position="start">$</InputAdornment> : undefined,
      }}
      sx={{
        "& input[type=number]": {MozAppearance: "textfield"},
        "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button": {
          WebkitAppearance: "none",
          margin: 0,
        },
      }}
      error={!!valueError}
    />
  </Box>
);

export default NumericValueInput;
